<template>
    <div>
    <rkm-table
            :fields="fields"
            :items="data.model.procedimentosSecundarios"
            hide-filters
        >
            <template #cell(actions)="{ item }">
                <rkm-button
                    :title="data.model.exportado ? 'Visualizar' : 'Editar'"
                    @click.stop="$refs.Modal.open(item)"
                    color="primary"
                    small
                >
                    <rkm-icon :icon="data.model.exportado ? 'eye' : 'pen'" />
                </rkm-button>

                <rkm-button
                    :disabled="data.model.exportado"
                    @click.stop="handleDestroy(item)"
                    color="danger"
                    title="Excluir"
                    small
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

// Mixins.
import { formats } from '@/mixins'

// Moment.
import moment from 'moment'

export default {
    components: { Modal },
    computed: {
        fields() {

            return [
                {
                    key: 'procedimento',
                    label: 'Procedimento',
                    formatter: v => `${this.formatProcedimento(v.codigo)} - ${v.nome}`,
                    sortable: true
                },
                { key: 'quantidade', label: 'Quantidade', sortable: true },
                { key: 'ocupacao.codigo', label: 'CBO', sortable: true },
                {
                    key: 'cidPrincipal',
                    label: 'CID principal',
                    formatter: v => v ? `${this.formatCid(v.codigo)} - ${v.nome}` : null,
                    sortable: true
                },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ]
        }
    },
    data: () => ({
        others: { moment },
    }),
    methods: {
        handleDestroy(item) {

            this.showDeleteConfirmation(
                'Tem certeza que deseja excluir o procedimento?',
                async () => this.data.model.procedimentosSecundarios.splice(
                    this.data.model.procedimentosSecundarios.findIndex(p => p.id === item.id)
                , 1)
            )
        },
    },
    mixins: [formats],
    props: {
        data: { type: Object, required: true },
    }
}
</script>